import GenericFilter from "./GenericFilter";
import { CEO_GENDER_COLOR_MAP } from "../../../lib/constants";
import styles from "../FilterPanel.module.css";
import type { Filters, FilterOptions, UpdateFilterFn, ToggleArrayFilterFn } from "../types";

type Props = {
  filters: Filters;
  filterOptions: FilterOptions;
  updateFilter: UpdateFilterFn;
  toggleArrayFilter: ToggleArrayFilterFn;
  isMobile: boolean;
  isActive: boolean;
};

const GenderFilters = ({
  filters,
  filterOptions,
  updateFilter,
  toggleArrayFilter,
  isMobile,
  isActive,
}: Props) => {
  return (
    <GenericFilter
      filterKey="ceoGenders"
      selectedValues={filters.ceoGenders || []}
      availableValues={filterOptions.ceoGenders ?? []}
      colorMap={CEO_GENDER_COLOR_MAP}
      updateFilter={updateFilter}
      toggleArrayFilter={toggleArrayFilter}
      isMobile={isMobile}
      isActive={isActive}
      radioName="gender-radio"
      gridClassName={styles.genderGrid}
    />
  );
};

export default GenderFilters;
